import styled from 'styled-components'

import FormContainer from 'components/FormContainer'
import theme from 'theme'

export const StyledFormContainer = styled(FormContainer)`
  max-width: 100%;
  margin: 0 auto 80px;
  box-shadow: ${theme.shadows.lgMedium};
  border-radius: 10px;

  &&& {
    width: 315px;
    padding-bottom: 0;
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    &&& {
      width: 100%;
    }
  }
`

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  font-size: 14px;
  line-height: 22px;
`

export const Grow = styled.div`
  flex: 1;
`

export const Label = styled.label`
  margin-right: 25px;
`

export const HeroText = styled.h1`
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 40px;
  text-align: center;
  max-width: 400px;
  
  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: 0 0 30px;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    max-width: 340px;
  }
`
